import React, { useEffect, useState } from 'react'
import ReactApexChart from 'react-apexcharts'
interface Iprops {
  chatStatus: any
}
export const PieChartAgent: React.FC<Iprops> = ({ chatStatus }) => {
  const [chartData, setChartData] = useState<any>({
    series: [
      Number(chatStatus[0]?.totalConversations) || 0,
      Number(chatStatus[0]?.totalConversationsResolved) || 0,
      Number(chatStatus[0]?.totalConversationsEscalated) || 0
    ],
    chart: {
      type: 'pie'
    },
    labels: ['Resolved', 'Escalated'],
    colors: ['#00E396', '#FF0000'],
    plotOptions: {},
    stroke: {
      show: false
    },
    dataLabels: {
      enabled: true,
      formatter(val: any, opts: any) {
        const name = opts.w.globals.labels[opts.seriesIndex]
        return [name, val.toFixed(1) + '%']
      }
    },
    legend: {
      position: 'bottom',
      horizontalAlign: 'left',
      markers: {
        width: 9,
        height: 9
      },
      itemMargin: {
        horizontal: 20,
        vertical: 0
      }
    }
  })

  useEffect(() => {
    setChartData({
      series: [
        Number(chatStatus[0]?.totalConversationsResolved) || 0,
        Number(chatStatus[0]?.totalConversationsEscalated) || 0
      ],
      chart: {
        type: 'pie'
      },
      labels: ['Resolved', 'Escalated'],
      plotOptions: {},
      stroke: {
        show: false
      },
      dataLabels: {
        enabled: true,
        formatter(val: any, opts: any) {
          const name = opts.w.globals.labels[opts.seriesIndex]
          return [name, val.toFixed(1) + '%']
        }
      },
      legend: {
        position: 'bottom',
        horizontalAlign: 'left',
        markers: {
          width: 9,
          height: 9
        },
        itemMargin: {
          horizontal: 20,
          vertical: 0
        }
      },
      colors: ['#00E396', '#FF0000']
    })
  }, [chatStatus])

  console.log(chatStatus)

  return (
    <>
      <div className='card card-xl-stretch mb-xl-8'>
        <div className='card-header border-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Conversation Status</span>
          </h3>
        </div>

        {/* <!--begin::Card body--> */}
        <div className='card-body'>
          <ReactApexChart options={chartData} series={chartData.series} type='pie' />
        </div>
      </div>
    </>
  )
}
